import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FilterByOptions, FolderListDataSource } from '@go-modules/services/folder-list-datasource/folder-list-datasource';
import { UserService, userServiceToken } from 'go-modules/models/user/user.service';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { ActiveBrandService } from '@go-modules/services/active-brand';

@Component({
	selector: 'folders-zero-state',
	templateUrl: './folders-zero-state.component.html',
	styleUrls: ['./folders-zero-state.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class FoldersZeroStateComponent implements OnInit {
	@Output() public createFolder = new EventEmitter();
	@Output() public openInvite = new EventEmitter();
	@Output() public filterByChange = new EventEmitter<FilterByOptions>();
	@Input() public canInvite = false;

	public showFilterAllButton$: Observable<boolean>;

	constructor (
		@Inject(userServiceToken) private userService: UserService,
		private folderListDataSource: FolderListDataSource,
		private translateService: TranslateService,
		public activeBrandService: ActiveBrandService
	) {}

	public ngOnInit (): void {
		this.showFilterAllButton$ = this.folderListDataSource.connect().pipe(
			map((folders) =>
				folders.length === 0 && this.folderListDataSource.getCurrentFilter() === FilterByOptions.CURRENT
			)
		);
	}

	public getTitle (): Observable<string> {
		if (this.folderListDataSource.filtered) {
			return this.translateService.get('folder_zero_state-no-folders');
		}
		if (this.userService.currentUser.isInstructor) {
			return this.translateService.get('common_welcome-to-goreact', this.activeBrandService.getTranslationParams());
		}
		return this.translateService.get('folder_zero_state-join-organization');
	}

	public getSubText (): Observable<string> {
		if (this.folderListDataSource.filtered) {
			return this.translateService.get('folder_zero_state-no-folders-subtext');
		}
		if (this.userService.currentUser.isInstructor) {
			return this.translateService.get('folder_zero_state-welcome-subtext');
		}
		return this.translateService.get('folder_zero_state-join-organization-subtext');
	}

	public showDefaultButtons (): boolean {
		return this.userService.currentUser.isInstructor && !this.folderListDataSource.filtered;
	}

	public showGraphic (): boolean {
		return !this.folderListDataSource.filtered;
	}

	public filterToAll (): void {
		this.filterByChange.emit(FilterByOptions.ALL);
	}
}
